import { render } from "./Navigation.vue?vue&type=template&id=10217a42&scoped=true"
import script from "./Navigation.vue?vue&type=script&lang=js"
export * from "./Navigation.vue?vue&type=script&lang=js"

import "./Navigation.vue?vue&type=style&index=0&id=10217a42&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-10217a42"

export default script